import axios from "axios";

// Global Axios Configuration.
export default axios.create({
  baseURL: "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
});
